export class ListSapSourcesFilterConditions {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "IdFilters",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "StringFilters",
            "format": ""
        },
        {
            "name": "sid",
            "baseName": "sid",
            "type": "StringFilters",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListSapSourcesFilterConditions.attributeTypeMap;
    }
    constructor() {
    }
}
